import React, { useEffect } from 'react';
import { scopedKey } from '@amzn/d2c-application-website-common';

/**
 * This page is the LWA redirect target. After successful auth, the backend redirects here
 * with ?success=true&expiry=SECONDS&csrf_token=TOKEN&state=STORAGE_SCOPE.
 * We store the auth state in localStorage (which triggers the storage event in the parent window)
 * and close this window.
 */
const CloseWindow: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const success = params.get('success');
    const expiry = params.get('expiry');
    const csrfToken = params.get('csrf_token');
    const scope = params.get('state') || undefined;

    if (success === 'true' && expiry) {
      try {
        const key = scopedKey('authState', scope);
        const expiryTimeMs = Number(expiry) * 1000;
        const existingJSON = localStorage.getItem(key);
        const existing = existingJSON ? JSON.parse(existingJSON) : {};
        const authState = {
          ...existing,
          expiryTime: expiryTimeMs,
          csrfToken: csrfToken || undefined,
        };
        localStorage.setItem(key, JSON.stringify(authState));
      } catch (e) {
        console.error('Failed to persist auth state in popup:', e);
      }
    }

    window.close();
  }, []);

  return <p>Completing sign in...</p>;
};

export default CloseWindow;
